/**
 * Haptic feedback wrapper para botones críticos en Live Mode.
 * En iOS PWA sólo funciona si el dispositivo lo permite; el `try` blindaje
 * evita crash en escritorio o navegadores sin soporte.
 */
export const haptic = (ms = 10) => {
  try {
    if (typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function') {
      navigator.vibrate(ms);
    }
  } catch (_e) {
    // Silencioso: haptic es opcional, no crítico.
  }
};

export default haptic;
